exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order__header[data-v-3cdd5fe5]{background-color:#6aceff;padding:65px 20px 0}.order__header .backlink[data-v-3cdd5fe5]{margin-bottom:5px}.order__header .order__header-title-container[data-v-3cdd5fe5]{display:flex;align-items:flex-end}.order__header img[data-v-3cdd5fe5]{width:100px;margin-left:35px}.order__header span[data-v-3cdd5fe5]{color:#fff;font-family:ClanFFBlack;font-size:25px;margin-top:25px;text-transform:uppercase;flex:1;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cdd5fe5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Order/OrderHeader.vue
// module id = 616
// module chunks = 0